import React, { useContext } from "react";
import { Modal, useNotifications } from "sprint-common-web";

import { useCloudFileApi } from "../../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CourseOfActionReference } from "../../../../../../common/types/CourseOfActionReference";
import { FixedBillingReference } from "../../../../../../common/types/FixedBillingReferfence";
import { WaitingForClientResponseDetailsForm } from "../../../../../common/waiting-for-client-response-form/WaitingForClientResponseDetailsForm";
import { CloudFileStatus } from "../../../../common/types/CloudFileStatus";
import { CloudFileListingContext } from "../../../CloudFileListingContext";

type CloudFileWaitingForClientResponseListingDialogProps = {
    cloudFileId: string;
    isOpen: boolean;
    onClose: () => void;
};

export const CloudFileWaitingForClientResponseListingDialog = ({
    isOpen,
    onClose,
    cloudFileId
}: CloudFileWaitingForClientResponseListingDialogProps): JSX.Element => {
    const { success, error } = useNotifications();
    const { requestFilesWaitingForClientResponse } = useCloudFileApi();
    const { updateCloudFileStatus } = useContext(CloudFileListingContext);

    const handleStatusDetailsChange = async ({
        courseOfAction,
        details,
        fixedBilling
    }: {
        details: string;
        courseOfAction: CourseOfActionReference;
        fixedBilling?: FixedBillingReference;
    }) => {
        try {
            await requestFilesWaitingForClientResponse({
                cloudFileId,
                details,
                courseOfActionId: courseOfAction.id,
                fixedBillingId: fixedBilling?.id
            });

            updateCloudFileStatus(cloudFileId, CloudFileStatus.WaitingForClientResponse, {
                courseOfAction: courseOfAction.name,
                fixedBilling: fixedBilling?.name,
                details
            });

            success("Cloud file successfully changed to Waiting for Client Response");
        } catch (e) {
            console.log(e);

            error("Cloud file status change to Waiting for Client Response failed");
        }

        onClose();
    };

    return (
        <Modal
            headerText="Change cloud file status to Waiting for Client Response"
            isBlocking={true}
            isOpen={isOpen}
            onDismiss={onClose}
        >
            <WaitingForClientResponseDetailsForm onConfirm={handleStatusDetailsChange} onCancel={onClose} />
        </Modal>
    );
};
